export const LOGO_HOVER_ANIMATION = { scale: 1.02 };
export const LOGO_TRANSITION = { duration: 0.3 };

export const GLOW_ANIMATION = { opacity: [0.4, 0.7, 0.4], scale: [1, 1.15, 1] };
export const GLOW_TRANSITION = { duration: 2.5, repeat: Infinity, ease: 'easeInOut' };

export const RING_ROTATION = { rotate: 360 };
export const RING_TRANSITION = { duration: 20, repeat: Infinity, ease: 'linear' };
export const RING_STYLE = { originX: '32px', originY: '32px' };

export const NODE_PULSE_ANIMATION = { scale: [1, 1.4, 1], opacity: [0.6, 1, 0.6] };
export const NODES = [
  { cx: 19, cy: 20, fill: '#FF6B35', transition: { duration: 1.8, repeat: Infinity } },
  { cx: 45, cy: 20, fill: '#4ECDC4', transition: { duration: 1.8, repeat: Infinity, delay: 0.4 } },
  { cx: 32, cy: 48, fill: '#FFD93D', transition: { duration: 1.8, repeat: Infinity, delay: 0.8 } },
];

export const ROCKET_ANIMATION = {
  x: [0, 10, 5, 15, 10, 20],
  y: [0, -8, -16, -24, -32, -40],
  opacity: [0, 1, 1, 1, 0.5, 0],
  scale: [0.8, 1, 1, 1, 0.9, 0.7],
};
export const ROCKET_TRANSITION = { duration: 3, repeat: Infinity, ease: 'easeOut', repeatDelay: 1 };

export const FIRE_ANIMATION = { scaleY: [1, 1.4, 1], opacity: [0.8, 1, 0.8] };
export const FIRE_TRANSITION = { duration: 0.3, repeat: Infinity };

export const SPARKLE_ANIMATION = { opacity: [0, 1, 0], scale: [0.5, 1, 0.5] };
export const SPARKLES = [
  { cx: 12, cy: 8, fill: '#FFD93D', transition: { duration: 0.8, repeat: Infinity } },
  { cx: 20, cy: 10, fill: '#4ECDC4', transition: { duration: 0.8, repeat: Infinity, delay: 0.3 } },
];

export const TEXT_INITIAL = { opacity: 0, x: -10 };
export const TEXT_ANIMATE = { opacity: 1, x: 0 };
export const TEXT_TRANSITION = { delay: 0.2 };

export const TEXT_FONT_STYLE = { fontFamily: 'system-ui, -apple-system, sans-serif' };
